/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S10_Li2_DescInputs */

const tr_iade_iptal_s10_li2_desc = /** @type {(inputs: Iade_Iptal_S10_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sipariş, fatura, müşteri ve ürün listeleri tablo formatında.`)
};

const en_iade_iptal_s10_li2_desc = /** @type {(inputs: Iade_Iptal_S10_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order, invoice, customer and product lists in table format.`)
};

const de_iade_iptal_s10_li2_desc = /** @type {(inputs: Iade_Iptal_S10_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestell-, Rechnungs-, Kunden- und Produktlisten im Tabellenformat.`)
};

const ru_iade_iptal_s10_li2_desc = /** @type {(inputs: Iade_Iptal_S10_Li2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Списки заказов, счетов, клиентов и товаров в табличном формате.`)
};

/**
* | output |
* | --- |
* | "Order, invoice, customer and product lists in table format." |
*
* @param {Iade_Iptal_S10_Li2_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s10_li2_desc = /** @type {((inputs?: Iade_Iptal_S10_Li2_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S10_Li2_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s10_li2_desc(inputs)
	if (locale === "de") return de_iade_iptal_s10_li2_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s10_li2_desc(inputs)
	return tr_iade_iptal_s10_li2_desc(inputs)
});